import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const DisclaimerWrapper = styled.div`
  margin-top: 2rem;
  width: 100%;

  p {
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: ${({ color }) =>
      color === 'white'
        ? themeGet('colors.white')
        : themeGet('colors.main-text')};
    text-align: ${({ alignment }) =>
      // eslint-disable-next-line no-nested-ternary
      alignment === 'left'
        ? 'left'
        : alignment === 'right'
          ? 'right'
          : 'center'};
  }
`;
